<template>
  <div v-if="isAvailable">
    <VRow v-if="!isMobile">
      <VCol cols="8">
        <VTextField
          v-model="q"
          :label="$t('search.one')"
          variant="underlined"
          append-icon="search"
          clear-icon="close"
          clearable
          @input="onInput"
          @click:clear="q = ''"
        />
      </VCol>

      <VCol cols="4">
        <VSelect
          v-model="sortOption"
          label="Сортировать по умолчанию"
          variant="underlined"
          :items="sortOptions"
          item-text="title"
          :item-value="item => item"
          @change="filter"
        />
      </VCol>
    </VRow>

    <template v-else>
      <div
        class="d-flex mb-2"
      >
        <template v-if="!showSearch">
          <VBtn
            :title="sortOption.title"
            text
            class="d-block flex-shrink-1 justify-start px-0"
            @click="showSort = true"
          >
            <VIcon>sort</VIcon>
            <span class="text-truncate">{{ sortOption.title || 'По умолчанию' }}</span>
          </VBtn>

          <VSpacer />

          <VBtn
            v-if="!showSearch"
            text
            class="justify-end px-0"
            @click="showSearch = true"
          >
            <VIcon>search</VIcon>
          </VBtn>
        </template>

        <VTextField
          v-else
          v-model="q"
          autofocus
          :label="$t('search.one')"
          variant="underlined"
          prepend-inner-icon="search"
          append-outer-icon="send"
          clear-icon="close"
          clearable
          @click:append-outer="onBlur"
          @click:clear="q = ''"
          @blur="onBlur"
        />
      </div>

      <VDialog
        v-model="showSort"
        fullscreen
      >
        <VCard>
          <VCardTitle class="headline">
            Выберите вариант сортировки
            <VSpacer />
            <VBtn
              :title="$t('close.one')"
              icon
              @click="showSort=false"
            >
              <VIcon>close</VIcon>
            </VBtn>
          </VCardTitle>

          <VDivider />

          <VCardText class="text--primary">
            <VList>
              <VListItem
                v-for="option in sortOptions"
                :key="option.key"
                class="option"
                @click="setOption(option)"
              >
                {{ option.title }}
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </VDialog>
    </template>
  </div>
</template>

<script>

export default {
  name: 'SessionsFilter',

  props: {
    value: {
      type: Array,
      default: () => []
    },

  },

  data () {
    return {
      q: '',
      sortOption: {},
      sortOptions: [
        { key: 'default', title: 'По умолчанию' },
        { key: 'alphabet-asc', title: 'По наименованию (от А до Я)' },
        { key: 'alphabet-desc', title: 'По наименованию (от Я до А)' },
        { key: 'start-date-asc', title: 'По дате начала обучения (по возрастанию)' },
        { key: 'start-date-desc', title: 'По дате начала обучения (по убыванию)' },
        { key: 'end-date-asc', title: 'По дате окончания обучения (по возрастанию)' },
        { key: 'end-date-desc', title: 'По дате окончания обучения (по убыванию)' },
        { key: 'summative-lesson-start-asc', title: 'По дате начала итогового урока (по возрастанию)' },
        { key: 'summative-lesson-start-desc', title: 'По дате начала итогового урока (по убыванию)' },
        { key: 'summative-lesson-end-asc', title: 'По дате окончания итогового урока (по возрастанию)' },
        { key: 'summative-lesson-end-desc', title: 'По дате окончания итогового урока (по убыванию)' },
      ],
      timeout: null,
      showSearch: false,
      showSort: false
    }
  },

  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.mobile
    },

    isAvailable () {
      return (this.isMobile && this.value?.length >= 3) || this.value?.length >= 6
    }
  },

  methods: {
    onInput () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.filter()
      }, 1000)
    },

    onBlur () {
      this.showSearch = false
      this.filter()
    },

    setOption (option) {
      this.sortOption = option
      this.showSort = false
      this.filter()
    },

    filter () {
      let filteredSessions = this.value

      if (this.q) {
        filteredSessions = filteredSessions.filter(session => session.course_title.toLowerCase().includes(this.q.toLowerCase()))
      }

      switch (this.sortOption.key) {
        case 'alphabet-asc':
          filteredSessions.sort((a, b) => a.course_title.localeCompare(b.course_title))
          break
        case 'alphabet-desc':
          filteredSessions.sort((a, b) => b.course_title.localeCompare(a.course_title))
          break
        case 'start-date-asc':
          filteredSessions.sort((a, b) => new Date(a.settings.session_starts_at) - new Date(b.settings.session_starts_at))
          break
        case 'start-date-desc':
          filteredSessions.sort((a, b) => new Date(b.settings.session_starts_at) - new Date(a.settings.session_starts_at))
          break
        case 'end-date-asc':
          filteredSessions.sort((a, b) => new Date(a.settings.session_ends_at) - new Date(b.settings.session_ends_at))
          break
        case 'end-date-desc':
          filteredSessions.sort((a, b) => new Date(b.settings.session_ends_at) - new Date(a.settings.session_ends_at))
          break
        case 'summative-lesson-start-asc':
          filteredSessions.sort((a, b) => new Date(a.settings.summative_starts_at) - new Date(b.settings.summative_starts_at))
          break
        case 'summative-lesson-start-desc':
          filteredSessions.sort((a, b) => new Date(b.settings.summative_starts_at) - new Date(a.settings.summative_starts_at))
          break
        case 'summative-lesson-end-asc':
          filteredSessions.sort((a, b) => new Date(a.settings.summative_ends_at) - new Date(b.settings.summative_ends_at))
          break
        case 'summative-lesson-end-desc':
          filteredSessions.sort((a, b) => new Date(b.settings.summative_ends_at) - new Date(a.settings.summative_ends_at))
          break
        default:
          break
      }

      this.$emit('change', filteredSessions || [])
    }
  }
}
</script>

<style lang="scss" scoped>
.option {
  border-radius: $border-radius-root;
  border: $border;
  margin-top: 1rem;
  margin-bottom: 1rem;
  cursor: pointer;
}
</style>
